(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('.ltv-pdp-main').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('form'), select = root.querySelector('[data-variant-select]');
      const quantity = form?.querySelector('[name="quantity"]');
      const cards = [...root.querySelectorAll('[data-variant-id]')];
      const thumbs = [...root.querySelectorAll('[data-gallery-image]')];
      const image = root.querySelector('.ltv-pdp-main-image');
      let currentImage = Math.max(0, thumbs.findIndex(el => el.classList.contains('is-active')));
      const showImage = index => {
        if (!image || !thumbs.length) return;
        currentImage = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[currentImage];
        image.removeAttribute('srcset'); image.removeAttribute('sizes');
        image.src = thumb.dataset.image; image.alt = thumb.dataset.imageAlt || root.dataset.productTitle;
        thumbs.forEach((el, i) => { el.classList.toggle('is-active', i === currentImage); if (i === currentImage) el.setAttribute('aria-current','true'); else el.removeAttribute('aria-current'); });
      };
      thumbs.forEach((el, i) => el.addEventListener('click', event => { event.preventDefault(); showImage(i); }));
      root.querySelectorAll('[data-gallery-step]').forEach(button => { button.hidden = false; button.addEventListener('click', () => showImage(currentImage + Number(button.dataset.galleryStep))); });
      const activeCard = () => cards.find(card => card.dataset.variantId === select?.value);
      const normalizeQuantity = () => {
        if (!quantity) return 1;
        const min = Number(quantity.min) || 1, step = Number(quantity.step) || 1;
        const max = quantity.max ? Number(quantity.max) : Infinity;
        let value = Number(quantity.value);
        if (!Number.isFinite(value)) value = min;
        value = min + Math.round((value - min) / step) * step;
        const alignedMax = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : max;
        quantity.value = Math.max(min, Math.min(alignedMax, value));
        root.querySelectorAll('[data-quantity-step]').forEach(button => { button.disabled = Number(button.dataset.quantityStep) < 0 ? Number(quantity.value) <= min : Number(quantity.value) + step > max; });
        return Number(quantity.value);
      };
      const updateWhatsApp = () => {
        const card = activeCard();
        const id = select?.value || form?.querySelector('[name="id"]')?.value;
        const url = new URL(root.dataset.productUrl, window.location.origin);
        if (id) url.searchParams.set('variant', id);
        const option = card ? `${root.dataset.waOption}: ${card.dataset.variantTitle}` : '';
        const price = card?.dataset.variantPrice || root.querySelector('[data-pdp-price]')?.textContent.trim();
        const text = [root.dataset.waIntro, root.dataset.productTitle, option, `${root.dataset.waQuantity}: ${normalizeQuantity()}`, `${root.dataset.waPrice}: ${price}`, url.href].filter(Boolean).join('\n');
        const link = root.querySelector('[data-pdp-whatsapp]');
        if (link) link.href = `https://wa.me/${root.dataset.phone.replace(/\D/g,'')}?text=${encodeURIComponent(text)}`;
      };
      const choose = (id, updateUrl = true) => {
        const card = cards.find(el => el.dataset.variantId === String(id));
        if (!card || !select) return;
        select.value = id;
        cards.forEach(el => { const active = el === card; el.classList.toggle('is-active',active); el.setAttribute('aria-pressed',String(active)); });
        root.querySelector('[data-pdp-price]').textContent = card.dataset.variantPrice;
        const stock = root.querySelector('[data-pdp-stock]'), available = card.dataset.variantAvailable === 'true';
        stock.textContent = available ? root.dataset.stockLabel : root.dataset.soldLabel; stock.classList.toggle('is-sold', !available);
        const add = root.querySelector('[data-pdp-add]'); add.disabled = !available; add.querySelector('span').textContent = available ? root.dataset.addLabel : root.dataset.soldLabel;
        const license = root.querySelector('[data-pdp-license]'); if (license) license.textContent = card.dataset.variantLicense;
        document.querySelectorAll('[data-pdp-license-secondary]').forEach(el => { el.textContent = card.dataset.variantLicense; });
        quantity.min = card.dataset.variantMin || '1'; quantity.step = card.dataset.variantStep || '1';
        if (card.dataset.variantMax) quantity.max = card.dataset.variantMax; else quantity.removeAttribute('max');
        if (card.dataset.variantImage && image) {
          const index = thumbs.findIndex(el => el.dataset.image === card.dataset.variantImage);
          if (index >= 0) showImage(index);
          else { image.removeAttribute('srcset'); image.src = card.dataset.variantImage; image.alt = card.dataset.variantAlt || root.dataset.productTitle; }
        }
        if (updateUrl) { const url = new URL(window.location.href); url.searchParams.set('variant', id); window.history.replaceState({},'',url); }
        updateWhatsApp();
      };
      if (select && cards.length) {
        root.querySelector('.ltv-pdp-variant-cards').hidden = false;
        select.hidden = true;
        const label = root.querySelector(`label[for="${select.id}"]`);
        if (label) label.removeAttribute('for');
        cards.forEach(card => card.addEventListener('click', () => choose(card.dataset.variantId)));
        select.addEventListener('change', () => choose(select.value));
        const requested = new URL(window.location.href).searchParams.get('variant');
        choose(cards.some(el => el.dataset.variantId === requested) ? requested : select.value, false);
      }
      root.querySelectorAll('[data-quantity-step]').forEach(button => { button.hidden = false; button.addEventListener('click', () => { quantity.value = normalizeQuantity() + Number(button.dataset.quantityStep) * (Number(quantity.step) || 1); updateWhatsApp(); }); });
      quantity?.addEventListener('change',updateWhatsApp);
      form?.addEventListener('submit',event => { normalizeQuantity(); if (select && !activeCard()) { event.preventDefault(); root.querySelector('.ltv-pdp-status').textContent = root.dataset.errorLabel; } });
      updateWhatsApp();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target.parentElement || document));
})();
